import React from 'react';
import LoadingSpinner from '@/components/ui/loading-spinner';
import { useI18n } from '@/hooks/use-i18n';

interface TranslatedLoadingSpinnerProps {
  textKey: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  withText?: boolean;
  fullHeight?: boolean;
  fullPage?: boolean;
  centerInParent?: boolean;
}

/**
 * Componente LoadingSpinner che utilizza le traduzioni per il testo
 */
const TranslatedLoadingSpinner: React.FC<TranslatedLoadingSpinnerProps> = ({
  textKey,
  size = 'md',
  withText = true,
  fullHeight = false,
  fullPage = false,
  centerInParent = true
}) => {
  const { t } = useI18n();
  
  return (
    <LoadingSpinner 
      text={t(textKey)}
      size={size}
      withText={withText}
      fullHeight={fullHeight}
      fullPage={fullPage}
      centerInParent={centerInParent}
    />
  );
};

export default TranslatedLoadingSpinner;
